import React from 'react';
import * as tConst from "../../../common/Constants";
import { Button, InputNumber, Select, Input } from 'antd';
import { SaveOutlined, PlusOutlined } from '@ant-design/icons'; // Import PlusOutlined icon
import { createChildrenTicket } from '../../../utils/ticketUtils';
import { formatDate } from '../../../utils/formatDate';

const ChartMenuForm = ({ selectedTicket, fromDate, toDate, assignedTo, initiaitve, jiraLink, onUpdateTicket, onSetRefresh, auth, onRefreshChildren }) => {
    const [planningPriority, setPlanningPriority] = React.useState(selectedTicket.planningPri);
    const [planningStatus, setPlanningStatus] = React.useState(selectedTicket.fields[tConst.AF_PLANNING_STATUS]);
    const [initiative, setInitiative] = React.useState(selectedTicket.fields[tConst.AF_INITIATIV]);
    const [teams, setTeams] = React.useState(selectedTicket.Teams);
    const [guestimate, setGuestimate] = React.useState(selectedTicket.Guestimate);



    const { Option } = Select;

    const _changed = (planningPriority !== selectedTicket.planningPri
        || planningStatus !== selectedTicket.fields[tConst.AF_PLANNING_STATUS]
        || initiative !== selectedTicket.fields[tConst.AF_INITIATIV]
        || guestimate !== selectedTicket.Guestimate
        // TODO: We need to look at how we can be smarter at calculating this 
        || teams !== selectedTicket.Teams
    );

    return (
        <>
            Period: &nbsp;
            {fromDate ? formatDate(fromDate) : ""} -{" "}
            {toDate ? formatDate(toDate) : ""} <br />
            {/* TODO: Editable Assignee - Make assignee editiable */}
            Assignee: {assignedTo ? assignedTo.displayName : "<Unassigned>"} <br />
            {/* TODO: Editable State - Rewrite this to be a drop down that can be changed */}
            Status: {selectedTicket.fields[tConst.AF_STATE]} <br />

            {/* TODO: Planning pri - create better tooling to avoid duplicate planning priorities */}
            Planning Status: &nbsp;
            <Select value={planningStatus} onChange={setPlanningStatus} style={{ width: 200 }}>
                {tConst.ADO_PLANNING_STATUSES.map(option => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select><br />
            {/* TODO: Edit Initiative - Create functionality for Type Ahead based on existing initiaitves */}
            Initiative:&nbsp;
            <Input value={initiative} onChange={(e) => setInitiative(e.target.value)} style={{ width: 300 }} />
            <a href={tConst.AZURE_DEVOPS_BASE_URI + "_search?type=workitem&text=initiative%3A%22" + initiaitve + "%22"} target="_blank" rel="noopener noreferrer">Open</a><br />

            
            Planning Priority: <InputNumber value={planningPriority} onChange={setPlanningPriority} /> &nbsp;&nbsp;  Guestimate: <InputNumber value={guestimate} onChange={setGuestimate} /> <br /><br />
            {selectedTicket.fields[tConst.AF_JIRA_LINK] && <>Jira Ref: <a href={jiraLink}>{selectedTicket.fields[tConst.AF_JIRA_LINK]}</a> <br /></>}
            <>Teams: </>
            <Select 
                value={teams} 
                onChange={setTeams} 
                mode="multiple"
                allowClear
                style={{ width: 500 }}>
                {tConst.TEAMS_LIST.map(option => (
                    <Option key={option.team} value={option.team}>
                        {option.label}
                    </Option>
                ))}
            </Select>
            {/* Add Team Children Button */}
            <Button
                type="default"
                icon={<PlusOutlined />} // Add the PlusOutlined icon
                onClick={() => {
                  
                    const prefix = "[Threat analysis] "
                    teams.forEach((team) => {
                        createChildrenTicket(auth, selectedTicket, team, null, prefix);
    
                    })

                    onRefreshChildren();
                    

                    // Add your logic for "Add Team Children" here
                    console.log("Add Team Children button clicked", teams);
                }}
            />


            {_changed &&
                <>
                    <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={() => {
                            if (onUpdateTicket) {
                                let _data = [];
                                if (selectedTicket.planningPri !== planningPriority) {
                                    _data.push({ attribute: "/fields/" + tConst.AF_PLANNING_PRIORITY, "value": planningPriority });
                                }
                                if (selectedTicket.fields[tConst.AF_PLANNING_STATUS] !== planningStatus) {
                                    _data.push({ attribute: "/fields/" + tConst.AF_PLANNING_STATUS, "value": planningStatus });
                                }
                                if (selectedTicket.fields[tConst.AF_INITIATIV] !== initiative) {
                                    _data.push({ attribute: "/fields/" + tConst.AF_INITIATIV, "value": initiative });
                                }
                                if (selectedTicket.Guestimate !== guestimate) {
                                    _data.push({ attribute: "/fields/" + tConst.AF_GUESTIMATE, "value": guestimate });
                                }
                                // TODO: We need to be smarter at how we calculate if teams has changed
                                if (selectedTicket.Teams !== teams){
                                    _data.push({ attribute: "/fields/" + tConst.AF_TEAMS, "value": teams.join(";") });
                                }
                                onUpdateTicket(selectedTicket.id, _data).then(() => {
                                    onSetRefresh();
                                });
                            }
                        }}
                    >
                        Save
                        {/* TODO: Fix refresh on save */}
                    </Button>
                    <br />
                </>
            }
        </>
    );
};

export default ChartMenuForm;